export default __webpack_public_path__ + "static/media/1941.6d1c79f4.png";